const DEFAULT_TIMEOUT = 15 * 1000

export default {

  namespaced: true,

  state: {
    count: 0,
    timeout: DEFAULT_TIMEOUT,
    timeoutDisabled: false,
  },

  mutations: {

    show (state, options = {}) {
      state.count = 1
      state.timeout = options?.timeout || DEFAULT_TIMEOUT
    },

    hide (state) {
      state.count = 0
    },

    setTimeoutDisabled (state, value) {
      state.timeoutDisabled = value
    },
  },

  actions: {

    show ({ state, commit }, options) {
      commit('show', options)
    },

    hide ({ state, commit }) {
      commit('hide')
    },

    setTimeoutDisabled ({ state, commit }, value) {
      commit('setTimeoutDisabled', value)
    },
  },
}
